export default __webpack_public_path__ + "static/media/Snd2.37fc2765.mp3";